
import { createAction, props } from '@ngrx/store';
import { ScheduleSummary } from './../../../api/models/schedule-summary.model';
import { Update } from '@ngrx/entity';

export const getThemeScheduleSummaryAction = createAction(
    '[ThemeScheduleSummary] Get Theme Schedule Summary for Location via service',
    props<{ locationId: number }>()
);

export const setThemeScheduleSummaryAction = createAction(
    '[ThemeScheduleSummary] Set Theme Schedule Summary for Location via service',
    props<{ themeScheduleSummaryList: ScheduleSummary[] }>()
);


export const addThemeScheduleSummarySuccess = createAction(
    '[ThemeScheduleSummary] Add Theme Schedule Summary successful for Location via service',
    props<{ themeScheduleSummary: ScheduleSummary }>()
);

export const updateThemeScheduleSummarySuccess = createAction(
    '[ThemeScheduleSummary] Update Theme Schedule Summary successful for Location via service',
    props<{ update: Update<ScheduleSummary> }>()
);

export const deleteThemeScheduleSummarySuccess = createAction(
    '[ThemeScheduleSummary] Delete Theme Schedule Summary successful for Location via service',
    props<{ themeId: number }>()
);

export const themeScheduleSummaryActionTypes = {
    getThemeScheduleSummaryAction,
    setThemeScheduleSummaryAction,
    addThemeScheduleSummarySuccess,
    updateThemeScheduleSummarySuccess,
    deleteThemeScheduleSummarySuccess
}
